import { FormBuilder, FormArray, Validators, FormGroup } from '@angular/forms';

export function mediasGroup (formBuilder: FormBuilder): FormArray {
    return formBuilder.array([]);
}

export function createMediaGroup (formBuilder: FormBuilder): FormGroup {
    return formBuilder.group({
        url: ['', Validators.required],
        name: [''],
        copyright: [''],
        introduction: formBuilder.group({
            title: [''],
        }),
        type: [''],
        idItem: [''],
    });
}
